import styled from 'styled-components'

export const VideoCardContainer = styled.li`
  list-style-type: none;
  display: flex;
  flex-direction: row;
  width: 100%;
  margin: 0px;
  margin-bottom: 20px;
  text-decoration: none;
  @media screen and (max-width: 576px) {
    flex-direction: column;
    justify-content: center;
    padding: 10px;
  }
`
export const ImgContainer = styled.div`
  width: 400px;
  margin-right: 10px;
  @media screen and (max-width: 576px) {
    width: 100%;
    height: 200px;
    margin: 0px;
  }
  @media screen and (max-width: 767px) {
    width: 250px;
  }
`
export const VideoCardThumnailImg = styled.img`
  height: 100%;
  width: 100%;
`

export const VideoCardDetails = styled.div`
  display: flex;
  flex-direction: column;
`
export const VideoCardTitle = styled.p`
  font-size: 22px;
  font-weight: 600;
  font-family: 'Roboto';
  margin-bottom: 8px;
  color: ${props => (props.theme === true ? '#f4f4f4' : '#424242')};
`

export const VideoCardChannelName = styled.p`
  font-family: 'Roboto';
  font-size: 18px;
  color: #7e858e;
`
export const VideoCardViewAndDuration = styled.ul`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 0px;
  margin: 0px;
`
export const VideoCardViews = styled.p`
  list-style: none;
  margin-right: 11px;
  font-family: 'Roboto';
  font-size: 15px;
  color: #7e858e;
`
export const VideoCardDuration = styled.p`
  font-family: 'Roboto';
  font-size: 12px;
  color: #7e858e;
`
export const LinkEl = styled.nav`
  text-decoration: none;
`
